// extracted by mini-css-extract-plugin
export default {"name":"GameInfo_name__e9Wy1","description":"GameInfo_description__2j9Ej"};